module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "min-h-screen w-full flex items-center justify-center p-4 text-white",
    staticStyle: {
      "background": "linear-gradient(to bottom, #2972db 0%, #163D75 100%)"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "w-full max-w-xl"
  }, [_c('div', {
    staticClass: "flex justify-center mb-4"
  }, [_c('span', {
    staticClass: "logo hidden"
  }), _vm._v(" "), _c('img', {
    staticClass: "h-16 w-auto select-none",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "logo fi360"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "relative text-xl font-bold text-center mb-4",
    attrs: {
      "id": "title"
    },
    on: {
      "click": _vm.openErrorDetails
    }
  }, [_vm._v("\n      " + _vm._s(_vm.txtInit) + "\n      "), _c('span', {
    staticClass: "pointSynchro1"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "pointSynchro2"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "pointSynchro3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "relative max-w-xl mx-auto text-sm"
  }, [_c('ul', {
    staticClass: "space-y-2"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_divers"
    }
  }, [_c('span', [_vm._v("Autres téléchargements")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center gap-3"
  }, [_c('span', {
    staticClass: "numberDivers text-sm"
  }, [_vm._v(_vm._s(this.completedSteps) + "/" + _vm._s(this.totalSteps))]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_detenteur"
    }
  }, [_c('span', [_vm._v("Téléchargement des détenteurs et installations")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_bouteille"
    }
  }, [_c('span', [_vm._v("Téléchargement des bouteilles")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_profil"
    }
  }, [_c('span', [_vm._v("Téléchargement du profil utilisateur")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_outils"
    }
  }, [_c('span', [_vm._v("Téléchargement des outillages")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_distri"
    }
  }, [_c('span', [_vm._v("Téléchargement des distributeurs")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_fluides"
    }
  }, [_c('span', [_vm._v("Téléchargement des fluides")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_op_bouteille"
    }
  }, [_c('span', [_vm._v("Téléchargement des opérations bouteille")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2",
    attrs: {
      "id": "synchro_otags"
    }
  }, [_c('span', [_vm._v("Téléchargement des Otags")]), _vm._v(" "), _c('span', {
    staticClass: "loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide text-white text-2xl leading-none"
  }, [_vm._v("✔")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3245a0f7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/InitLoading.vue
// module id = 1024
// module chunks = 0